import script from "./CreateNewList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateNewList.vue?vue&type=script&setup=true&lang=ts"

import "./CreateNewList.vue?vue&type=style&index=0&id=a6346ef8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6346ef8"]])

export default __exports__